"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AngleUpDown = exports.TableCell = exports.TableRow = exports.TableHeaderCell = exports.TableHeader = exports.TableContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectIcons = require("@wealthmigrate/architect-icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ TABLE > STYLE ] ######################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var TableContainer = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__TableContainer",
  componentId: "ysls9y-0"
})(["display:table;width:100%;border-radius:var(--radius-small);background:var(--color-white);padding:var(--gutter-small);"]); // 3.1. END ....................................................................
// 3.2. TABLE HEADER ...........................................................


exports.TableContainer = TableContainer;

var TableHeader = _styledComponents["default"].ul.withConfig({
  displayName: "indexstyle__TableHeader",
  componentId: "ysls9y-1"
})(["display:table-header-group;background:var(--color-white);"]); // 3.2. END ....................................................................
// 3.3. TABLE HEADER CELL ......................................................


exports.TableHeader = TableHeader;

var TableHeaderCell = _styledComponents["default"].li.withConfig({
  displayName: "indexstyle__TableHeaderCell",
  componentId: "ysls9y-2"
})(["&:before{display:none;}display:table-cell;color:var(--color-darker);font-weight:var(--weight-bold);padding:var(--gutter-small);border-bottom:solid 2px var(--color-light);&:not(:last-child){border-right:solid 1px var(--color-light);}svg{width:10px;height:10px;}"]); // 3.3. END ....................................................................
// 3.4. TABLE ROW ..............................................................


exports.TableHeaderCell = TableHeaderCell;

var TableRow = _styledComponents["default"].ul.withConfig({
  displayName: "indexstyle__TableRow",
  componentId: "ysls9y-3"
})(["display:table-row;&:last-child{li{border-bottom:none!important;}}"]); // 3.4. END ....................................................................
// 3.5. TABLE CELL .............................................................


exports.TableRow = TableRow;

var TableCell = _styledComponents["default"].li.withConfig({
  displayName: "indexstyle__TableCell",
  componentId: "ysls9y-4"
})(["&:before{display:none;}display:table-cell;padding:var(--gutter-small);color:var(--color--darkest);font-weight:var(--weight-regular);border-bottom:1px solid var(--color-light);&:not(:last-child){border-right:1px solid var(--color-light);}"]); // 3.5. END ....................................................................
// 3.6. TABLE CELL .............................................................


exports.TableCell = TableCell;
var AngleUpDown = (0, _styledComponents["default"])(_architectIcons.AngleRightIcon).withConfig({
  displayName: "indexstyle__AngleUpDown",
  componentId: "ysls9y-5"
})(["position:absolute;right:var(--gutter-small);", ""], function (_ref) {
  var order = _ref.order;
  return order ? "transform: rotate(-90deg);" : "transform: rotate(90deg);";
}); // 3.6. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################

exports.AngleUpDown = AngleUpDown;